/**
 * Generates a key based on the provided UUIDs.
 * This key is used to identify the item in the list.
 * It forces re-rendering of the item in the list when that item's image is updated.
 *
 * @param {string} uuid - The original UUID.
 * @param {string} updatedResourceUuid - The updated resource UUID.
 * @returns {string} The generated key, which is a string concatenation of the original UUID and the updated UUID (if they match), separated by a dash.
 */

export const getItemKey = (uuid, updatedResourceUuid) => {
  const updatedUuid = updatedResourceUuid === uuid ? uuid : ''

  return `${uuid}-${updatedUuid}`
}
